<div class="container">
  <div class="row justify-content-center">
    <div class="col-md-8">
      <div class="card-group mb-0">
        <div class="card p-4">
          <div class="card-body">
            <h1>Identity Information</h1>
            <p>This page is here for development and debug reasons.</p>
            <p>
              <strong>No one else can access this page and get <em>your</em> identity information.</strong>
            </p>
            <p>
              The following is the technical identity information about the user you are logged in as. Everything here
              is also accessible through your browser's built-in development tools as soon as you have logged in. These
              tools are available to anyone by pressing F12 in most browsers.
            </p>
            <button type="button" class="btn btn-danger px-4" (click)="onLogoutClick()">Logout</button>
            <button type="button" class="btn btn-warning px-4" (click)="onRequestNewAccessToken()">
              Request New Access Token
            </button>
          </div>
          <div class="card-body">
            <h1>HTTP Header</h1>
            <p>
              You can use something like
              <a href="https://chrome.google.com/webstore/detail/modheader/idgpnmonknjnojddfkpgkljpfnnfcklj?hl=en"
                >ModHeader</a
              >
              or <a href="https://www.getpostman.com/">Postman</a> to access the WebApp or API with the below HTTP
              header information.
            </p>
            <h2><pre>authorization</pre></h2>
            <pre>Bearer {{ auth?.accessToken }}</pre>
            <h1>Auth0</h1>
            <h2><pre>auth.accessToken</pre></h2>
            <pre>{{ auth?.accessToken }}</pre>
            <h2><pre>auth.idToken</pre></h2>
            <pre>{{ auth?.idToken }}</pre>
            <h2><pre>auth.createdAt</pre></h2>
            <pre>{{ auth?.createdAt }}</pre>
            <h2><pre>iso8601(auth.createdAt)</pre></h2>
            <pre>{{ createdAtISO }}</pre>
            <h2><pre>auth.expiresAt</pre></h2>
            <pre>{{ auth?.expiresAt }}</pre>
            <h2><pre>iso8601(auth.expiresAt)</pre></h2>
            <pre>{{ expiresAtISO }}</pre>
            <h1>Identity</h1>
            <h2><pre>identity.app_user</pre></h2>
            <pre>{{ identity?.app_user | json }}</pre>
            <h2><pre>identity.app_customer</pre></h2>
            <pre>{{ identity?.app_customer | json }}</pre>
            <h2><pre>identity.app_membership</pre></h2>
            <pre>{{ identity?.app_membership | json }}</pre>
          </div>
          <div class="card-body">
            <h1>Features</h1>
            <p>
              <span *ngFor="let feature of appFeatures">{{ feature.feature_name }} <br /></span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
